import { Fragment, useEffect, useState, useRef } from 'react'
import PageLayout from '../Layouts/PageLayout'
import Spinner from '../FieldComponets/Spinner';
import { useDispatch, useSelector } from 'react-redux';
import { PAGES } from '../../Constants/CommonConstants';
import { MaterialReactTable } from 'material-react-table'
import { paginationQuery, handleSearch } from '../../utils/GlobalHelper';
import type { ColumnFiltersState, PaginationState } from '@tanstack/react-table';
import React from 'react';
import { getDate, getDateFormatData } from '../../utils/Helper';
import { Link, useNavigate } from 'react-router-dom';
import { setItemToStorage } from '../../utils/Helper';
import ToastDefault from '../FieldComponets/Toast';
import { DashboardRedirectionAction } from '../../Redux/Action/CommonAction';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import { LinkButtons } from "../FieldComponets/LinkButtons";
import { userPicUrl } from '../../utils/Helper';
import { NotificationlistGetAction } from '../../Redux/Action/NotificationsAction';
import { useIntl } from 'react-intl';

function Notifications() {

  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const intl = useIntl();
  const formRef = useRef<HTMLFormElement>(null);
  const notificationList = useSelector((state: any) => state.NotificationState);
  const [data, setData] = useState<any>([]);
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
  const [openSerach, setOpenSerach] = useState(false)
  const [sorting, setSorting] = useState<any>(['ASC']);

  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: PAGES?.pageIndex,
    pageSize: PAGES?.pageSize
  });
  const [searchValue, setSearchValue] = useState<any>('');
  const [rowCount, setRowCount] = useState(0);

  const columns: any = [
    {
      accessorKey: 'S.NO',
      header: intl.formatMessage({ id: "s_no" }),
      accessorFn: (row: Object, index: number) => {
        const currentPage = pagination.pageIndex + 1 || 1; // Assuming current page number, default to 1 if not provided
        const itemsPerPage = pagination.pageSize || 10; // Assuming items per page, default to 10 if not provided
        const startIndex = (currentPage - 1) * itemsPerPage;
        const serialNumber = startIndex + index + 1;
        return serialNumber;
      },
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
      size: 50,
    },
    {
      accessorKey: 'notification_params.title',
      header: intl.formatMessage({ id: "title" }),
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'receiver',
      header: intl.formatMessage({ id: "receiver" }),
      accessorFn: (row: { receiver: any; }) => {
        return row?.receiver == '1' 
        ? intl.formatMessage({ id: "all" }) 
        : row?.receiver == '2' 
        ? intl.formatMessage({ id: "customer" }) 
        : row?.receiver == '3' 
        ? intl.formatMessage({ id: "salon" }) 
        : row?.receiver == '4' || row?.receiver === 4
        ? intl.formatMessage({ id: "admin_label" })
        : intl.formatMessage({ id: "other_label" });      },
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'notification_params.body',
      header: intl.formatMessage({ id: "description" }),
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'created_at1',
      header: intl.formatMessage({ id: "created_date" }),
      accessorFn: (row: { created_at: any; }) => getDate(row.created_at),
      // dateSetting: { locale: "en-GB" },
      size: 100,
      filterVariant: 'date',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      if (!data?.length) {
        setLoading(true);
      } else {
        setIsRefetching(true);
      }
      try {
        let query: any = paginationQuery(
          pagination.pageIndex,
          pagination.pageSize,
          sorting,
          searchValue,
          columnFilters
        );
        dispatch(DashboardRedirectionAction('RESET'));
        await dispatch(NotificationlistGetAction(query));
      } catch (error) {
        setIsError(true);
        return;
      }
      setIsError(false);
      setLoading(false);
      setIsRefetching(false);
    };
    fetchData();
  }, [
    columnFilters,
    // searchValue,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    openSerach
  ]);
  useEffect(() => {
    setData(notificationList?.data?.data?.rows);
    setRowCount(notificationList?.data?.data?.count);
  }, [notificationList?.data]);

  const resetSearchfilter = () => {
    setSearchValue('')
    if (formRef.current) {
      formRef.current.reset();
    }
    const columnFilters = [
      { id: "search", value: "" },
      { id: "receiver", value: "" },
    ]
    setColumnFilters(columnFilters)

  }
  const handleserach = (e: any) => {
    e.preventDefault()
    const columnFilters = [
      { id: "receiver", value: searchValue?.user_type}
    ]
    setColumnFilters(columnFilters)
  }

  const handleInput =(e:any)=>{
    const {name , value} = e.target
    setSearchValue((serach:any)=>({...serach, [name]:value}))
  }

  return (
    <Fragment>
      {(loading || notificationList?.loading) ? <Spinner /> : ""}


      <PageLayout
        title={intl.formatMessage({ id: "notifications_management" })}
        breadcrumbs={{
          secLast: { 'link': '/notifications', 'name': intl.formatMessage({ id: "notifications_management" }) },
        }}
        buttons={[
          { url: '/notification-add', className: 'btn btn-primary', text: intl.formatMessage({ id: "add_notification" }), show: true }, // This button will be shown
        ]}
      >
         <form ref={formRef} onSubmit={handleserach}>
          <div className="row gy-3 align-items-end mb-4">
            <div className='col-sm-6 col-md-4 col-xl-3'>
              <label>{intl.formatMessage({ id: "search" })}</label>
              <div className="input-group w-100">
                <div className="input-group">
                  <span className="input-group-text fa-solid fa-magnifying-glass " id="basic-addon1"> <i className="fas fa-search"></i></span>
                  <input type='text' id="saerchId" name='search' className="form-control m-0" placeholder={intl.formatMessage({ id: "search_by_title" })} onChange={handleInput} />
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 col-xl-3">
              <label>{intl.formatMessage({ id: "all_users" })}</label>
              <select className='form-select shadow-none' name="user_type" id="cars" onChange={handleInput}  >
                <option value="">{intl.formatMessage({ id: "select_type" })}</option>
                <option value="1">{intl.formatMessage({ id: "all_user" })}</option>
                <option value="2">{intl.formatMessage({ id: "all_customer" })}</option>
                <option value="3">{intl.formatMessage({ id: "all_salon" })}</option>
              </select>
            </div>
            <div className="col-md-4 col-xl-3">
              <button className='btn theme-bg text-white me-2'>{intl.formatMessage({ id: "filter" })}</button>
              <button className='btn btn-success' onClick={() => resetSearchfilter()} >{intl.formatMessage({ id: "reset" })}</button>
            </div>
            
          </div>
            
        </form>
     
        {
          data &&
          <MaterialReactTable
            columns={columns}
            data={data}
            enableGlobalFilter={true}

            enableHiding={false}
            enableColumnFilters={false}
            enableDensityToggle={false}
            enableColumnActions={false}
            enableFullScreenToggle={false}
            positionToolbarAlertBanner="top"
            initialState={{ showColumnFilters: false }}
            manualFiltering
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={isError ? { color: 'error', children: intl.formatMessage({ id: "error_loading_data" }), } : undefined}
            muiSearchTextFieldProps={{
              placeholder: intl.formatMessage({ id: "search_from_name" }),
            }}
            onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={(value: any) => handleSearch(
              value,
              setIsError,
              setLoading,
              setIsRefetching,
              setSearchValue,
            )
            }
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={rowCount}
            state={{
              columnFilters,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
          />
        }
        <ToastDefault />
      </PageLayout>
    </Fragment>
  )
}

export default Notifications
